import React from 'react';
import {
  ArrowLeftRight, Truck, Container, Car, Globe, Boxes,
  Package, MapPin, FileCheck, Shield,
  Network, Sliders, Eye, Users
} from 'lucide-react';
import ServicePageTemplate from '../components/ServicePageTemplate';

const LandFreight = () => {
  return (
    <ServicePageTemplate
      heroTitle="Land Freight"
      heroImage="/img/land-freight.jpg"
      slug="land-freight"
      introText={[
        'Denver Logistics Private Limited provides reliable and cost-effective land freight solutions for domestic and cross-border transportation.',
        'With a strong transportation network and experienced logistics team, we ensure safe, timely, and efficient delivery of cargo while maintaining complete visibility throughout the shipment process.',
      ]}
      services={[
        'Door-to-Door Delivery',
        'Full Truck Load (FTL)',
        'Less Than Truck Load (LTL)',
        'Dedicated Vehicle Services',
        'Cross-Border Transportation',
        'Project Cargo Handling',
        'Pick-up & Delivery Services',
        'Cargo Tracking & Tracing',
        'Customs Clearance Support',
        'Cargo Insurance',
      ]}
      serviceIcons={[
        ArrowLeftRight, Truck, Container, Car, Globe, Boxes,
        Package, MapPin, FileCheck, Shield
      ]}
      benefits={[
        { title: 'Reliable Network', description: 'Strong transportation network covering domestic and cross-border routes.' },
        { title: 'Flexible Options', description: 'FTL, LTL, and dedicated vehicle services for all cargo sizes.' },
        { title: 'Complete Visibility', description: 'Real-time tracking and tracing throughout the shipment process.' },
        { title: 'Experienced Team', description: 'Skilled logistics professionals ensuring safe and timely delivery.' },
      ]}
      benefitIcons={[Network, Sliders, Eye, Users]}
      callout={{
        eyebrow: 'RELIABLE ROAD TRANSPORTATION.',
        sub: 'Anywhere. Anytime.',
        ctaLabel: 'TALK TO OUR LAND FREIGHT TEAM',
      }}
      faq={[
        { q: 'What is the difference between FTL and LTL?', a: 'FTL (Full Truck Load) means your cargo occupies an entire truck. LTL (Less Than Truck Load) shares truck space with other shipments. FTL offers faster transit and is cost-effective for larger shipments, while LTL is ideal for smaller loads.' },
        { q: 'Do you offer cross-border road transportation?', a: 'Yes. We provide cross-border land freight services with full customs clearance support, documentation handling, and regulatory compliance for seamless movement across international borders.' },
        { q: 'How do you ensure cargo safety during transit?', a: 'We use GPS-tracked vehicles, experienced drivers, secure loading practices, and cargo insurance coverage. Real-time tracking allows you to monitor your shipment throughout the journey.' },
      ]}
    />
  );
};

export default LandFreight;
